import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { ConfirmedModalComponent } from './features/modals/confirmed-modal/confirmed-modal.component';
import { AcknowledgmentModalComponent } from './features/modals/acknowledgment-modal/acknowledgment-modal.component';
import { RegisterUserComponent } from './features/login/modal/register-user/register-user.component';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { ManagerMenuComponent } from './features/manager/manager-menu/manager-menu.component';
import { NewItemComponent } from './features/manager/manager-items/modal-contents/new-item/new-item.component';
import { HttpClientModule } from '@angular/common/http';
import { RestartItemsComponent } from './features/manager/manager-items/modal-contents/restart-items/restart-items.component';
import { GiftBagModalComponent } from './features/modals/gift-bag-modal/gift-bag-modal.component';
import { GiftBagCardComponent } from './features/modals/gift-bag-modal/gift-bag-card/gift-bag-card.component';
import { GiftBagExistisModalComponent } from './features/modals/gift-bag-existis-modal/gift-bag-existis-modal.component';
import { EndListModalComponent } from './features/modals/end-list-modal/end-list-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmedModalComponent,
    AcknowledgmentModalComponent,
    RegisterUserComponent,
    ManagerMenuComponent,
    NewItemComponent,
    RestartItemsComponent,
    GiftBagModalComponent,
    GiftBagCardComponent,
    GiftBagExistisModalComponent,
    EndListModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    ReactiveFormsModule,
    HttpClientModule,
    ModalModule.forRoot(),
    FormsModule
  ],
  providers: [BsModalRef, ScrollToService],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmedModalComponent,
    AcknowledgmentModalComponent,
    RegisterUserComponent,
    NewItemComponent,
    RestartItemsComponent,
    GiftBagModalComponent,
    GiftBagExistisModalComponent,
    EndListModalComponent
  ]
})
export class AppModule { }
